import { ComponentProps } from 'react';
import styled from 'styled-components';
import {
  ColorProps,
  LayoutProps,
  SpaceProps,
  color,
  compose,
  layout,
  space,
  flexbox,
  FlexboxProps,
  fontSize,
  FontSizeProps,
} from 'styled-system';
import { ThemedProps } from '@lower-financial/core-components/src/styles/utils/theme-utils';

type BaseLabelProps = {
  bold?: boolean;
  disabled?: boolean;
};

export const Label = styled.label<BaseLabelProps & FontSizeProps & ColorProps & LayoutProps & SpaceProps & FlexboxProps>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  ${ (props: ThemedProps & BaseLabelProps) => props.theme.Label[props.bold
    ? 'bold'
    : 'book'] };
  color: ${ (props: ThemedProps & BaseLabelProps) => (props.disabled
    ? 'var(----disabled-content)'
    : 'var(--input)')};
  ${ compose(color, layout, space, flexbox, fontSize) };
`;

export type LabelProps = ComponentProps<typeof Label>;

